export default __webpack_public_path__ + "static/ai@2x-e7548e063604408e28dd5382a56652fa.png";